'use client'

import { createContext, useEffect, useState, type PropsWithChildren } from 'react'
import { evalConsent } from '@/libs/consent/consent'
import { ConsentData } from '@/types/consent'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

const emptyData = { consentReady: false }
export const ConsentContext = createContext<ConsentData>(emptyData)

type ConsentProviderProps = PropsWithChildren & {
  cookies: RequestCookie[]
}

export const ConsentProvider = ({ cookies, children }: ConsentProviderProps) => {
  const [consentData, setConsentData] = useState<ConsentData>(emptyData)

  useEffect(() => {
    try {
      evalConsent(cookies, setConsentData)
    } catch (error) {
      // Handle evalConsent errors gracefully
      console.error('Error evaluating consent:', error)
      setConsentData({
        consentReady: true,
        status: 'error',
      })
    }
  }, [])

  return <ConsentContext.Provider value={consentData}>{children}</ConsentContext.Provider>
}
